import React, { useContext, useEffect, useRef, useState } from "react";
import "./Banner.css";

import banner1 from "../../../Assets/Images/method01.png";
import banner2 from "../../../Assets/Images/method2.png";
import banner11 from "../../../Assets/Images/M1.jpg";
import banner21 from "../../../Assets/Images/M2.jpg";
import iphone1 from "../../../Assets/Images/M3.jpg";
import iphone2 from "../../../Assets/Images/M4.jpg";
import iphone3 from "../../../Assets/Images/M5.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Controller } from "swiper";
import "swiper/css";
import { useNavigate } from "react-router-dom";
import { UserAuthContext } from "../../../Contexts/UserAuthContext";
import { sentences } from "./data";

const Banner = () => {
  const { AIuser, AiLogOut } = useContext(UserAuthContext);
  const [currentSentence, setCurrentSentence] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [controlledSwiper1, setControlledSwiper1] = useState(null);
  const [controlledSwiper2, setControlledSwiper2] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const preloadImages = (imageUrls) => {
      imageUrls.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    };
    preloadImages([banner1, banner2, banner11, banner21]);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
    }, 3000); // Change image every 5 seconds

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  useEffect(() => {
    const updateSentence = () => {
      const randomIndex = Math.floor(Math.random() * sentences.length);
      setCurrentSentence(sentences[randomIndex]);
    };

    updateSentence(); // set initial sentence
    const intervalId = setInterval(updateSentence, 15000); // update every  seconds

    return () => clearInterval(intervalId); // clean up on unmount
  }, []);

  return (
    <div className="banner-container">
      <div className="container banner-main row mx-auto px-4">
        
        {/* Large device method-1 banner  */}
        <div className="col-12 col-md-6 col-lg-6 position-relative d-none d-md-flex d-lg-flex">
          <Swiper
            slidesPerView={1}
            loop={true}
            centeredSlides={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Controller]}
            className="mySwiper"
            onSwiper={setControlledSwiper1}
          > 
            
            {/* new image  */}
            <SwiperSlide>
              <img
                className="img-fluid"
                src={iphone3}
                alt="A complete social media marketing manager"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                onClick={() => navigate("/ver2/do-it-yourself")}
                className="img-fluid"
                src={banner1}
                alt="A complete social media marketing manager"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                onClick={() => navigate("/ver2/do-it-yourself")}
                className="img-fluid"
                src={banner11}
                alt="A complete social media marketing manager"
              />
            </SwiperSlide>


            
          </Swiper>
          
        </div>

       
        <div className="col-6 d-none d-md-flex d-lg-flex position-relative">
          <Swiper
            slidesPerView={1}
            loop={true}
            centeredSlides={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
            onSwiper={setControlledSwiper2}
          >
            <SwiperSlide>
              <img
                
                className="img-fluid"
                src={iphone2}
                alt="image"
                style={{ cursor: "pointer" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                onClick={() => navigate("/ver2/let-us-do-it-for-you")}
                className="img-fluid"
                src={banner2}
                alt="image"
                style={{ cursor: "pointer" }}
              />
             
            </SwiperSlide>
            <SwiperSlide>
              <img
                onClick={() => navigate("/ver2/let-us-do-it-for-you")}
                className="img-fluid"
                src={banner21}
                alt="image"
                style={{ cursor: "pointer" }}
              />
             
            </SwiperSlide>

          </Swiper>
          
        </div>
        {/* banner in slider for small device */}

        <div className="col-12 d-md-none d-lg-none">
          <Swiper
            slidesPerView={1}
            loop={true}
            centeredSlides={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          > 
            <SwiperSlide>
              <div className="position-relative">
                <img
                  className="img-fluid"
                  src={iphone3}
                  alt="A complete social media marketing manager"
                />
               
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="position-relative">
                <img
                  className="img-fluid"
                  src={iphone2}
                  alt="A complete social media marketing manager"
                />
               
              </div>
            </SwiperSlide>
            
            <SwiperSlide>
              <div className="position-relative">
                
                <img
                  onClick={() => navigate("/ver2/do-it-yourself")}
                  className="img-fluid"
                  src={banner1}
                  alt="A complete social media marketing manager"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="">
                <img
                  onClick={() => navigate("/ver2/let-us-do-it-for-you")}
                  className="img-fluid"
                  src={banner2}
                  alt="image"
                  style={{ cursor: "pointer" }}
                />
                
              </div>
            </SwiperSlide>
            
            <SwiperSlide>
              <div className="position-relative">
                <img
                  onClick={() => navigate("/ver2/do-it-yourself")}
                  className="img-fluid"
                  src={banner11}
                  alt="A complete social media marketing manager"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="">
                <img
                  onClick={() => navigate("/ver2/let-us-do-it-for-you")}
                  className="img-fluid"
                  src={banner21}
                  alt="image"
                  style={{ cursor: "pointer" }}
                />
              </div>
            </SwiperSlide>
            
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Banner;
